export const SET = '@app/SET'
export const FETCHED = '@app/FETCHED'
